import './article.scss';

import { isEmpty } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Barcodes } from '@pos/app/scripts/services/barcodes';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Persist } from '@core/app/scripts/services/persist';
import { PosSearch } from '@pos/app/scripts/services/pos-search';

/*
 * Component responsible for /article route.
 */
angular
  .module('posApp')
  .directive(
    'article',
    (
      $log: ng.ILogService,
      $timeout: ng.ITimeoutService,
      barcodes: Barcodes,
      broadcaster: Broadcaster,
      displayMessage: DisplayMessage,
      loadArticleInfo,
      navigateTo: NavigateTo,
      persist: Persist,
      pos,
      posSearch: PosSearch,
      posInit,
      translate,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./article.html').default,

      link: function ($scope: any) {
        const $translate = translate;

        $scope.selectedRow = null;
        $scope.selectedLine = -1;
        $scope.listData = [];
        $scope.completeListData = [];
        $scope.filterCopy = [];
        $scope.smartList = [];
        $scope.columns = [];
        $scope.openColumnPopup = false;
        $scope.copyData = {};
        $scope.selectAll = false;
        $scope.articlesInitilised = false;

        if (persist.get('articleShowStockOnly')) {
          $scope.showStockOnly = JSON.parse(
            persist.get('articleShowStockOnly'),
          );
        } else {
          $scope.showStockOnly = false;
        }

        $scope.filterValues = {
          art_barcode: '',
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: '',
          l: '',
          m: '',
          n: '',
          s: '',
        };
        $scope.search = {
          art_barcode: '',
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: '',
          g: '',
          h: '',
          i: '',
          l: '',
          m: '',
          n: '',
          s: '',
        };
        $scope.pageRef = 'pos.route#pos';

        function applyStockOnlyFilter() {
          if ($scope.showStockOnly) {
            let filteredData = $scope.listData.filter((item) => item.v > 0);
            $scope.listData = filteredData;
          } else {
            $scope.listData = $scope.completeListData;
          }
        }

        // generate article list
        $scope.fillArticleList = () => {
          let article, c, colNames, colWidth, r;
          let count = 1;

          if (isEmpty(barcodes.db)) {
            const message = $translate.instant('ArticlesNotLoaded');
            displayMessage.message({
              message: message,
              type: 'info',
            });
            return;
          }

          for (r in barcodes.db) {
            article = barcodes.db[r];
            article.art_barcode = r;
            article.no = count;
            $scope.listData.push(article);
            count++;
          }
          $scope.completeListData = $scope.listData;
          applyStockOnlyFilter();

          $scope.articlesInitilised = true;
        };

        $scope.setDefaultColumns = () => {
          const defaultColumns = [
            {
              name: 'barcode',
              ngmodel: 'art_barcode',
              title: 'Barcode',
              label: $translate.instant('Barcode'),
              checked: true,
              factor: 1,
            },
            {
              name: 'articleCode',
              ngmodel: 'a',
              title: 'Article Code',
              label: $translate.instant('Article Code'),
              checked: true,
              factor: 1,
            },
            {
              name: 'suplcode',
              ngmodel: 'i',
              title: 'Supplier code',
              label: $translate.instant('Supplier code'),
              checked: false,
              factor: 1,
            },
            {
              name: 'description',
              ngmodel: 'b',
              title: 'Description',
              label: $translate.instant('Description'),
              checked: true,
              factor: 1.2,
            },
            {
              name: 'brand',
              ngmodel: 'c',
              title: 'Brand',
              label: $translate.instant('Brand'),
              checked: true,
              factor: 1,
            },
            {
              name: 'size',
              ngmodel: 'f',
              title: 'Size',
              label: $translate.instant('Size'),
              checked: true,
              factor: 0.5,
            },
            {
              name: 'subcolor',
              ngmodel: 's',
              title: 'Size',
              label: $translate.instant('Sub color'),
              checked: true,
              factor: 0.5,
            },
            {
              name: 'colorcode',
              ngmodel: 'g',
              title: 'Color code',
              label: $translate.instant('Color code'),
              checked: true,
              factor: 0.5,
            },
            {
              name: 'colordesc',
              ngmodel: 'h',
              title: 'Color description',
              label: $translate.instant('Color description'),
              checked: true,
              factor: 0.5,
            },
            {
              name: 'colorTheme ',
              ngmodel: 'n',
              title: 'Color Theme',
              label: $translate.instant('ColorTheme'),
              checked: false,
              factor: 0.8,
            },
            {
              name: 'ccode',
              ngmodel: 'm',
              title: 'Supplier color code',
              label: $translate.instant('Supplier color code'),
              checked: false,
              factor: 0.5,
            },
            {
              name: 'suplcolor',
              ngmodel: 'l',
              title: 'Supplier color',
              label: $translate.instant('Supplier color'),
              checked: false,
              factor: 1,
            },
            {
              name: 'price',
              ngmodel: 'd',
              title: 'Price',
              label: $translate.instant('Price'),
              checked: true,
              factor: 0.9,
            },
            {
              name: 'group',
              ngmodel: 'e',
              title: 'Group',
              label: $translate.instant('Group'),
              checked: true,
              factor: 1,
            },
          ];

          return defaultColumns;
        };

        $scope.filterColumns = () => {
          const storedValues = [];
          //Add the columns that are checked in the list to the columns filter
          for (const s in $scope.columns) {
            storedValues.push($scope.columns[s].checked);
          }
          persist.set('articleListColumns', JSON.stringify(storedValues));
          calculateTotalCoulumnFactor();
        };

        let totColFactor = 0;

        $scope.$on('pageShow', () => {
          //Update the smart list after the DOM is created
          broadcaster.send('updatesmartlistheight');
          //Attempt to set focus on the first field
          $scope.setFocusFirstField();
        });

        //This function will run whenever the page is shown
        let i;

        for (i in $scope.search) {
          if ($scope.search[i]) {
            $log.log('Refreshing Article List');
            $scope.refresh();
            break;
          }
        }
        if (!$scope.articlesInitilised) {
          $scope.fillArticleList();
        }

        // Set the column values
        $scope.columns = $scope.setDefaultColumns();
        // Take the checked values from localStorage and load them into the column object
        if (persist.get('articleListColumns')) {
          const storedColumns = JSON.parse(persist.get('articleListColumns'));
          if (typeof storedColumns[0] === 'boolean') {
            for (i in $scope.columns) {
              $scope.columns[i].checked = !!storedColumns[i];
            }
          } else {
            // This was the old way as an array of objects, now we only store booleans
            for (i in storedColumns) {
              if (storedColumns[i].checked) {
                $scope.columns[i].checked = storedColumns[i].checked;
              }
            }
          }
        } else {
          $scope.columns = $scope.setDefaultColumns();
        }

        //Add the default shop to the shop filter
        $scope.filterColumns();
        // Force the page list to resize the first time when viewing.
        // Otherwise the controls fall out of view
        broadcaster.send('forceFitToBottom');

        $scope.setFocusFirstField = () => {
          if ($scope.columns && $scope.columns[0] && $scope.columns[0].name) {
            for (const i in $scope.columns) {
              if ($scope.columns[i].checked) {
                broadcaster.send('setFocus', $scope.columns[i].name);
                break;
              }
            }
          }
        };

        /*
         * Calculate the total column factor (used to resize the columns proportionally)
         */
        function calculateTotalCoulumnFactor() {
          totColFactor = 0;
          for (const i in $scope.columns) {
            if ($scope.columns[i].checked) {
              totColFactor += $scope.columns[i].factor;
            }
          }
        }

        $scope.refreshArticleList = () => {
          $scope.filterColumns();
        };

        $scope.selectAllColumns = () => {
          for (const s in $scope.columns) {
            $scope.columns[s].checked = $scope.selectAll;
          }
          $scope.filterColumns();
        };

        $scope.toggleColumnPopup = () => {
          $scope.openColumnPopup = $scope.openColumnPopup ? false : true;
        };

        // Instantiate these variables outside the watch
        let filterTextTimeout;
        //Watch the search properties for changes, then add a timeout so the real
        //filter isn't changed immediately
        $scope.$watch(
          'filterValues',
          (val) => {
            if (filterTextTimeout) {
              $timeout.cancel(filterTextTimeout);
            }

            if (val.art_barcode) {
              val.art_barcode = val.art_barcode.replace('#', '');
            }
            $scope.search = angular.copy(val);
          },
          true,
        );

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.getClass = (ind) => {
          if (ind === $scope.selectedLine) {
            return 'ui-btn-active';
          } else {
            return 'inactive';
          }
        };

        $scope.getStyle = (ind) => {
          let colWidth = 0,
            colWidthText = '0%',
            i,
            listRowRatio;

          if ($scope.columns[ind] && $scope.columns[ind].checked) {
            colWidth = ($scope.columns[ind].factor / totColFactor) * 100;
            colWidthText = colWidth.toFixed(2) + '%';
          }

          return {
            width: colWidthText,
          };
        };

        $scope.selectCurrentLine = (currentLine) => {
          $scope.selectedRow = currentLine;
          $scope.toggleSelect(currentLine.no);
        };

        $scope.toggleSelect = (ind) => {
          $scope.selectedLine = ind;
        };

        $scope.refresh = () => {
          //Reset filters and data
          $scope.filterValues = {
            art_barcode: '',
            a: '',
            b: '',
            c: '',
            d: '',
            e: '',
            f: '',
            s: '',
            g: '',
            h: '',
            l: '',
            m: '',
            n: '',
            s: '',
          };
          $scope.search = {
            art_barcode: '',
            a: '',
            b: '',
            c: '',
            d: '',
            e: '',
            f: '',
            g: '',
            h: '',
            l: '',
            m: '',
            n: '',
            s: '',
          };
        };

        // get selected article from the list
        $scope.onSelectArticle = () => {
          if ($scope.selectedRow) {
            posSearch.scan($scope.selectedRow.art_barcode);
          }
          pos.selectedMenu = 1;

          navigateTo(posInit.pageRef);
        };

        $scope.onArticleInfo = () => {
          if ($scope.selectedRow) {
            // TODO replace by ref in article-info/ when works as expected
            loadArticleInfo('pos.route#article');

            navigateTo(
              `pos.route#article-info/${$scope.selectedRow.art_barcode}`,
            );
          }
        };

        $scope.updateStockOnlyFilter = () => {
          persist.set(
            'articleShowStockOnly',
            JSON.stringify($scope.showStockOnly),
          );

          applyStockOnlyFilter();
        };
      },
    }),
  );
